import { DragEvent, MouseEvent, useCallback } from 'react'

import { ListingPicture } from '@lib/components'

import styles from './styles.module.scss'
import type { AttachmentListingCardProps } from './types'

export const AttachmentListingCard = ({
  cardData,
  listingLink,
}: AttachmentListingCardProps) => {
  const handleAnchorDragStart = useCallback((event: DragEvent<HTMLAnchorElement>) => {
    event.preventDefault()
  }, [])
  const handleAnchorClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()
  }, [])

  const cardLabelParts = [cardData.title, cardData.subtitle, cardData.price].filter(
    (value): value is string => Boolean(value)
  )
  const cardAriaLabel = cardLabelParts.join(' · ')

  return (
    <a
      className={styles.listingCard}
      href={listingLink}
      target="_blank"
      rel="noopener noreferrer"
      draggable={false}
      onDragStart={handleAnchorDragStart}
      onClick={handleAnchorClick}
      aria-label={cardAriaLabel || cardData.price}
    >
      <ListingPicture
        url={cardData.imageUrl}
        alt={cardData.imageAlt}
        className={styles.picture}
        size="extraLarge"
        showPlaceholder
      />
      <div className={styles.infoContainer}>
        <div className={styles.price}>{cardData.price}</div>
        <div className={styles.details}>
          {cardData.title && (
            <div className={styles.title} title={cardData.title}>
              {cardData.title}
            </div>
          )}
          {cardData.subtitle && (
            <div className={styles.subtitle} title={cardData.subtitle}>
              {cardData.subtitle}
            </div>
          )}
        </div>
      </div>
    </a>
  )
}
